const stateList = [
  {id:0,state: "", generic: 1, state_spec: 0, disabled: true },
  {id: 1, state: "Alabama", generic: 1, state_spec: 0, disabled: false},
  {id: 2, state: "Alaska", generic: 1, state_spec: 0, disabled: false},
  {id: 3, state: "American Samoa", generic: 1, state_spec: 0, disabled: false},
  {id: 4, state: "Arizona", generic: 1, state_spec: 0, disabled: false},
  {id: 5, state: "Arkansas", generic: 1, state_spec: 0, disabled: false},
  {id: 6, state: "California", generic: 1, state_spec: 0, disabled: false},
  {id: 7, state: "Colorado", generic: 1, state_spec: 0, disabled: false},
  {id: 8, state: "Connecticut", generic: 1, state_spec: 0, disabled: false},
  {id: 9, state: "Delaware", generic: 1, state_spec: 0, disabled: false},
  {id: 10, state: "District Of Columbia", generic: 1, state_spec: 0, disabled: false},
  {id: 11, state: "Federated States Of Micronesia", generic: 1, state_spec: 0, disabled: false},
  {id: 12, state: "Florida", generic: 1, state_spec: 0, disabled: false},
  {id: 13, state: "Georgia", generic: 1, state_spec: 0, disabled: false},
  {id: 14, state: "Guam", generic: 1, state_spec: 0, disabled: false},
  {id: 15, state: "Hawaii", generic: 1, state_spec: 0, disabled: false},
  {id: 16, state: "Idaho", generic: 1, state_spec: 0, disabled: false},
  {id: 17, state: "Illinois", generic: 1, state_spec: 0, disabled: false},
  {id: 18, state: "Indiana", generic: 1, state_spec: 0, disabled: false},
  {id: 19, state: "Iowa", generic: 1, state_spec: 0, disabled: false},
  {id: 20, state: "Kansas", generic: 1, state_spec: 0, disabled: false},
  {id: 21, state: "Kentucky", generic: 1, state_spec: 0, disabled: false},
  {id: 22, state: "Louisiana", generic: 1, state_spec: 0, disabled: false},
  {id: 23, state: "Maine", generic: 1, state_spec: 0, disabled: false},
  {id: 24, state: "Marshall Islands", generic: 1, state_spec: 0, disabled: false},
  {id: 25, state: "Maryland", generic: 1, state_spec: 0, disabled: false},
  {id: 26, state: "Massachusetts", generic: 1, state_spec: 0, disabled: false},
  {id: 27, state: "Michigan", generic: 1, state_spec: 0, disabled: false},
  {id: 28, state: "Minnesota", generic: 1, state_spec: 0, disabled: false},
  {id: 29, state: "Mississippi", generic: 1, state_spec: 0, disabled: false},
  {id: 30, state: "Missouri", generic: 1, state_spec: 0, disabled: false},
  {id: 31, state: "Montana", generic: 1, state_spec: 0, disabled: false},
  {id: 32, state: "Nebraska", generic: 1, state_spec: 0, disabled: false},
  {id: 33, state: "Nevada", generic: 1, state_spec: 0, disabled: false},
  {id: 34, state: "New Hampshire", generic: 1, state_spec: 0, disabled: false},
  {id: 35, state: "New Jersey", generic: 1, state_spec: 0, disabled: false},
  {id: 36, state: "New Mexico", generic: 1, state_spec: 0, disabled: false},
  {id: 37, state: "New York", generic: 1, state_spec: 0, disabled: false},
  {id: 38, state: "North Carolina", generic: 1, state_spec: 0, disabled: false},
  {id: 39, state: "North Dakota", generic: 1, state_spec: 0, disabled: false},
  {id: 40, state: "Northern Mariana Islands", generic: 1, state_spec: 0, disabled: false},
  {id: 41, state: "Ohio", generic: 1, state_spec: 0, disabled: false},
  {id: 42, state: "Oklahoma", generic: 1, state_spec: 0, disabled: false},
  {id: 43, state: "Oregon", generic: 1, state_spec: 0, disabled: false},
  {id: 44, state: "Palau", generic: 1, state_spec: 0, disabled: false},
  {id: 45, state: "Pennsylvania", generic: 1, state_spec: 0, disabled: false},
  {id: 46, state: "Puerto Rico", generic: 1, state_spec: 0, disabled: false},
  {id: 47, state: "Rhode Island", generic: 1, state_spec: 0, disabled: false},
  {id: 48, state: "South Carolina", generic: 1, state_spec: 0, disabled: false},
  {id: 49, state: "South Dakota", generic: 1, state_spec: 0, disabled: false},
  {id: 50, state: "Tennessee", generic: 1, state_spec: 0, disabled: false},
  {id: 51, state: "Texas", generic: 1, state_spec: 0, disabled: false},
  {id: 52, state: "Utah", generic: 1, state_spec: 0, disabled: false},
  {id: 53, state: "Vermont", generic: 1, state_spec: 0, disabled: false},
  {id: 54, state: "Virgin Islands", generic: 1, state_spec: 0, disabled: false},
  {id: 55, state: "Virginia", generic: 1, state_spec: 1, disabled: false},
  {id: 56, state: "Washington", generic: 1, state_spec: 0, disabled: false},
  {id: 57, state: "West Virginia", generic: 1, state_spec: 0, disabled: false},
  {id: 58, state: "Wisconsin", generic: 1, state_spec: 0, disabled: false},
  {id: 59, state: "Wyoming", generic: 1, state_spec: 0, disabled: false}
];

export default stateList;
